
import { Component, Vue } from "vue-property-decorator";
import { MetaInfo } from "vue-meta";
// import Navbar from "@/components/Utility/Navbar.vue";
// import Footer from "@/components/Utility/Footer.vue";
import SitePromoBanner from "@/components/Utility/SitePromoBanner.vue";
import JoinusModal from "@/components/JoinUs/JoinusModal.vue";
@Component({
  components: {
    // Navbar,
    // Footer,
    SitePromoBanner,
    JoinusModal,
  },
})
export default class JoinUs extends Vue {
  metaInfo(): MetaInfo {
    return {
      title: "成為師虎來了合作師傅｜免費加入，彈性接案",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "水電、木工、裝潢、清潔等專業技術人員注意：加入師虎來了免繳月費與廣告費，24 小時彈性接案、收入有保障，還有專屬技術客服協助您成功接單。",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "成為師虎來了合作師傅｜免費加入，彈性接案",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "水電、木工、裝潢、清潔等專業技術人員注意：加入師虎來了免繳月費與廣告費，24 小時彈性接案、收入有保障，還有專屬技術客服協助您成功接單。",
        },
      ],
      link: [
        {
          vmid: "canonical",
          rel: "canonical",
          href: "https://www.fdtigermaster.com/JoinUs",
        },
      ],
    };
  }

  //data
  boo = false;
  //hook
  created() {
    this.boo = "__PRERENDER_INJECTED" in window;
  }
  mounted(): void {
    this.$bvModal.show("join-us-modal");
    setTimeout(() => {
      const modals = document.querySelectorAll("#join-us-modal___BV_modal_outer_");

      if (modals.length > 1) {
        for (let i = 1; i < modals.length; i++) {
          modals[i].remove();
        }
      }
    }, 300)
  }
}
